export default "__VITE_ASSET__DAEM6SOy__"